// extracted by mini-css-extract-plugin
export default {"cls1":"TZ_WasWDTAAUnzjhrnjW","cls2":"WdkpdNVJ2K8E_FZOVNrl TZ_WasWDTAAUnzjhrnjW"};